import { InsuranceInsurance, TypeDate } from '@/types/api'

type InsuranceDateInput = TypeDate | null | undefined

export function typeDateToTimestamp(date: InsuranceDateInput): number | null {
  if (date == null || typeof date !== 'object' || Object.keys(date).length === 0) {
    return null
  }
  if (!date.year || date.year === -1 || date.year <= 0) {
    return null
  }
  return new Date(
    date.year + '-' + ('0' + date.month).slice(-2) + '-' + ('0' + date.day).slice(-2)
  ).getTime()
}

export function typeDateToInputString(date: InsuranceDateInput): string {
  if (typeDateToTimestamp(date) === null) {
    return ''
  }
  return date.year + '-' + ('0' + date.month).slice(-2) + '-' + ('0' + date.day).slice(-2)
}

function stringDateToTimestamp(date: string | null | undefined): number | null {
  if (date == null || date === '') {
    return null
  }
  return new Date(date).getTime()
}

function startOfToday(): number {
  const today = new Date()
  today.setHours(0, 0, 0, 0)
  return today.getTime()
}

function isActiveByTimestamps(start: number | null, end: number | null, today: number): boolean {
  if (start !== null && start > today) {
    return false
  }
  if (end !== null && end < today) {
    return false
  }
  return true
}

export function isInsuranceActive(insurance: Pick<InsuranceInsurance, 'startDate' | 'endDate'>): boolean {
  const today = startOfToday()
  return isActiveByTimestamps(
    typeDateToTimestamp(insurance.startDate),
    typeDateToTimestamp(insurance.endDate),
    today
  )
}

export function isInsuranceActiveFromDateStrings(
  startDate: string | null | undefined,
  endDate: string | null | undefined
): boolean {
  const today = startOfToday()
  return isActiveByTimestamps(
    stringDateToTimestamp(startDate),
    stringDateToTimestamp(endDate),
    today
  )
}
